var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BjDrawerForm",
    {
      ref: "BjDrawerForm",
      attrs: { form: _vm.form, "label-width": "120px", width: "800px" },
      on: { handleConfirm: _vm.handleConfirm },
    },
    [
      _c("BjDivider"),
      [
        _c(
          "el-table",
          {
            staticStyle: { width: "100%" },
            attrs: { data: _vm.tableData, border: "", script: "" },
          },
          [
            _c("el-table-column", {
              attrs: { label: "SKU", prop: "skuCode", align: "center" },
            }),
            _c("el-table-column", {
              attrs: {
                label: _vm.$t("BusinessPurchaseOrderList.dataForm.Purchase"),
                prop: "planQty",
                align: "center",
              },
            }),
            _c("el-table-column", {
              attrs: {
                label: _vm.$t("BusinessPurchaseOrderList.dataForm.received"),
                prop: "alreadyQty",
                align: "center",
                width: "173",
              },
            }),
            _c("el-table-column", {
              attrs: {
                label: _vm.$t("BusinessPurchaseOrderList.dataForm.Difference"),
                prop: "difference",
                align: "center",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(_vm._s(scope.row.planQty - scope.row.alreadyQty)),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: _vm.$t("BusinessPurchaseOrderList.dataForm.tolerant"),
                prop: "dataFaultToleranceQty",
                align: "center",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("BjInputNumber", {
                        model: {
                          value: scope.row.dataFaultToleranceQty,
                          callback: function ($$v) {
                            _vm.$set(scope.row, "dataFaultToleranceQty", $$v)
                          },
                          expression: "scope.row.dataFaultToleranceQty",
                        },
                      }),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }